import React from 'react';
import { Link } from 'react-router-dom';
import { ACCOUNT_DELETION } from '../routes/paths';
import DownloadApp from '../components/DownloadApp';
import './Home.css';

const steps = [
  ['01', 'You’re invited', 'Open the personal invitation link shared by your host.'],
  ['02', 'Join the celebration', 'Follow the invitation to sign in and connect with your event.'],
  ['03', 'Keep the memories', 'Upload your photos and bring everyone’s favourite moments together.'],
];

function Home() {
  return (
    <div className="home-page">
      <a className="home-skip-link" href="#home-main">Skip to content</a>


      <main id="home-main" className="home-container">
        <section className="home-hero" aria-labelledby="home-title">
          <div className="home-hero-copy">
            <p className="home-eyebrow"><span aria-hidden="true" /> GOOD TIMES. ALL TOGETHER.</p>
            <h1 id="home-title">Every event.<br />Every moment.<br /><span>One happy place.</span></h1>
            <p className="home-intro">From the first invitation to the last photo, bring your celebration together with Click AI.</p>
            <p id="join-event" className="home-invitation-note">Have an invitation? Open the link shared by your host to join the celebration.</p>
          </div>

          <div className="home-art" aria-hidden="true">
            <div className="home-art-orbit" />
            <span className="home-spark home-spark-one">✦</span>
            <span className="home-spark home-spark-two">✧</span>
            <div className="home-memory home-memory-back"><div className="home-memory-scene"><span>✦</span><span>✦</span><span>✦</span></div><p>A little magic, a lot of memories.</p></div>
            <div className="home-ticket">
              <div className="home-ticket-top"><span>CLICK AI EVENTS</span><span>✳</span></div>
              <div className="home-ticket-art"><span>✳</span><span>✳</span><span>✳</span></div>
              <p className="home-ticket-kicker">THE BEST MOMENTS ARE SHARED</p>
              <p className="home-ticket-title">You’re<br />invited.</p>
              <div className="home-ticket-bottom"><span>A celebration to remember</span><span>↗</span></div>
            </div>
            <div className="home-art-note"><span className="home-note-icon">♡</span><div>More than an event.<br /><strong>A memory together.</strong></div></div>
          </div>
        </section>

        <section id="how-it-works" className="home-how" aria-labelledby="home-how-title">
          <div className="home-section-heading"><p className="home-eyebrow">LESS PLANNING. MORE CELEBRATING.</p><h2 id="home-how-title">Good memories start here.</h2></div>
          <div className="home-steps">{steps.map(([number, title, description]) => (
            <article className="home-step" key={number}><span className="home-step-number">{number}</span><h3>{title}</h3><p>{description}</p></article>
          ))}</div>
        </section>
        <DownloadApp />
      </main>
      <footer className="home-footer home-container"><span>Click AI</span><p>A place for your people. A home for your memories.</p><Link to={ACCOUNT_DELETION}>Delete your account</Link></footer>
    </div>
  );
}

export default Home;
